import { createApp, nextTick } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';

import App from './App.vue'
import HomePage from './components/top_level/HomePage.vue'
// oms/bday
// import LoginPage from './components/top_level/LoginPage.vue'
import LoginPage2 from './components/top_level/LoginPage2.vue'
import NewAppointmentPage from './components/top_level/NewAppointmentPage.vue'
import AppointmentsPage from './components/top_level/AppointmentsPage.vue'
import IconsPage from './components/top_level/IconsPage.vue'
import { useUserStore } from '@/stores/user';

import { Locale } from 'vant';
import ruRU from 'vant/es/locale/lang/ru-RU';
Locale.use('ru-RU', ruRU);

import 'vant/lib/index.css';
import './assets/global.css';

const app = createApp(App);

const DEFAULT_TITLE = 'MedPlanner';
const routes = [
	{
		path: '/',
		name: 'home',
		component: HomePage,
	},
	{
		path: '/login',
		name: 'login',
		component: LoginPage2,
		meta: {
			title: 'Войти',
		},
	},
	{
		path: '/new-appointment',
		name: 'new-appointment',
		component: NewAppointmentPage,
		meta: {
			title: 'Новая запись',
		},
	},
	{
		path: '/appointments',
		name: 'appointments',
		component: AppointmentsPage,
		meta: {
			title: 'Записи к врачам',
		},
	},
	{
		path: '/icons',
		name: 'icons',
		component: IconsPage,
	},
]

axios.defaults.baseURL = 'https://medplanner.ru/api/v1/';

const pinia = createPinia();

const router = createRouter({
	history: createWebHistory(),
	routes,
});
router.beforeEach((to, from) => {
	const userStore = useUserStore();
	if (!userStore.isAuthenticated && !['login', 'home', 'icons'].includes(to.name)) {
		return { name: 'login' };
	}
});
router.afterEach((to, from) => {
	nextTick(() => {
		if (to.meta.title) {
			document.title = to.meta.title + '. ' + DEFAULT_TITLE;
		} else {
			document.title = DEFAULT_TITLE;
		}
	});
});

app.use(router, axios);
app.use(pinia);
app.mount('#app');
